export default __webpack_public_path__ + "static/media/record_bar-yellow.3c29bfb6.svg";